import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const isAuthPath = path =>
  /register|login|recover|verification|verify|change-password/.test(path);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/dashboard",
      redirect: "/dashboard/exchange",
      name: "dashboard",
      component: () => {
        return import(/* webpackChunkName: "dashboard" */ "./views/modules/dashboard/Dasboard");
      },
      children: [
        {
          path: "exchange",
          name: "exchange",
          component: () =>
            import(/* webpackChunkName: "exchange" */ "./views/modules/dashboard/components/exchange/Exchange")
        },
        {
          path: "profile",
          name: "profile",
          component: () =>
            import(/* webpackChunkName: "profile" */ "./views/modules/user/Profile")
        }
      ]
    },
    {
      path: "/signup",
      name: "signup",
      component: () => {
        return import(/* webpackChunkName: "signup" */ "./views/modules/auth/Auth");
      },
      children: [
        {
          path: "login",
          name: "login",
          component: () =>
            import(/* webpackChunkName: "login" */ "./views/modules/auth/components/LoginForm")
        },
        {
          path: "register",
          name: "register",
          component: () =>
            import(/* webpackChunkName: "register" */ "./views/modules/auth/components/RegisterForm")
        }
      ]
    },
    {
      path: "/verification",
      name: "verification",
      component: () =>
        import(/* webpackChunkName: "verification" */ "./views/modules/auth/components/Verification")
    },
    {
      path: "/user/verify",
      name: "verificationCompleted",
      component: () =>
        import(/* webpackChunkName: "Verificationcompleted" */ "./views/modules/auth/components/VerificationCompleted")
    },
    {
      path: "/recover",
      name: "recover",
      component: () =>
        import(/* webpackChunkName: "recover" */ "./views/modules/auth/components/ResetPassword")
    },
    {
      path: "/change-password",
      name: "changePassword",
      component: () =>
        import(/* webpackChunkName: "recover" */ "./views/modules/auth/components/ChangePassword")
    },
    {
      path: "/incoming/exchange/raw",
      name: "rawFileDownload",
      component: () =>
        import(/* webpackChunkName: "rawfiledownload" */ "./views/modules/dashboard/RawFileDownload")
    },
    {
      path: "/version",
      name: "version",
      component: () =>
        import(/* webpackChunkName: "version" */ "./views/Version")
    },
    {
      path: "*",
      redirect: "/dashboard"
    }
  ]
});

router.beforeEach((to, from, next) => {
  const user = localStorage.getItem("user");
  if (
    /incoming\/exchange\/raw/.test(to.fullPath) ||
    /version/.test(to.fullPath)
  ) {
    next();
  } else {
    if (!user && !isAuthPath(to.fullPath)) {
      next("/signup/login");
    } else {
      if (user && isAuthPath(to.fullPath)) {
        next("/dashboard");
      } else {
        next();
      }
    }
  }
});

export default router;
